
const StringTool = {

    stringToUTF8Array(str)  {
        let ret = [];
      
        for(let i = 0; i < str.length; i++) {
            let charCode = str.charCodeAt(i);
      
            if(charCode < 0x80) {
                ret.push(charCode);
            } else if(charCode < 0x800) {
                ret.push(
                    0xc0 | (charCode >> 6),
                    0x80 | (charCode & 0x3f)
                );
            } else if(charCode < 0x10000) {
                ret.push(
                    0xe0 | (charCode >> 12),
                    0x80 | ((charCode >> 6) & 0x3f),
                    0x80 | (charCode & 0x3f)
                );
            } else {
                i++;
                charCode = 0x10000 + (((charCode & 0x3ff) << 10) | (str.charCodeAt(i) & 0x3ff));
                ret.push(
                    0xf0 | (charCode >> 18),
                    0x80 | ((charCode >> 12) & 0x3f),
                    0x80 | ((charCode >> 6) & 0x3f),
                    0x80 | (charCode & 0x3f)
                );
            }
        }
        return ret;
    },

    stringFromUTF8Array(data) {
        let str = '';

        for(let i = 0; i < data.length; i++) {
            let value = data[i];
            if(value === 0) break;
            
            if(value < 0x80) {
                str += String.fromCharCode(value);
            } else if(value > 0xBF && value < 0xE0) {
                if(i + 1 >= data.length) break;
                str += String.fromCharCode((value & 0x1F) << 6 | data[i + 1] & 0x3F);
                i += 1;
            } else if(value > 0xDF && value < 0xF0) {
                if(i + 2 >= data.length) break;
                str += String.fromCharCode((value & 0x0F) << 12 | (data[i + 1] & 0x3F) << 6 | data[i + 2] & 0x3F);
                i += 2;
            } else {
                if(i + 3 >= data.length) break;
                let charCode = ((value & 0x07) << 18 | (data[i + 1] & 0x3F) << 12 | (data[i + 2] & 0x3F) << 6 | data[i + 3] & 0x3F) - 0x010000;
                str += String.fromCharCode(charCode >> 10 | 0xD800, charCode & 0x03FF | 0xDC00); 
                i += 3;
            }
        }
        return str;
    },

    binaryStringToArray(str)    {
        let ret = [];
        for(const codePoint_ of str) {
            let codePoint = codePoint_.codePointAt(0);
            ret.push(codePoint);
        }
        return ret;
    },

    base64fromURL(str)    {
        return str.replace(/-/g, '+').replace(/_/g, '/');
    },

    base64toURL(str)    {
        return str.replace(/\+/g, '-').replace(/\//g, '_');
    },

    bytesToBase64(bytes) {
        const binString = String.fromCodePoint(...bytes);
        return btoa(binString);
    },

    base64ToBytes(base64) {
        const binString = atob(base64);
        return this.binaryStringToArray(binString);
    }
};

export default StringTool;